import Vue from "vue"
import Router from "vue-router"

import Index from "@/pages/index.vue"
import About from "@/pages/About.vue"
import Products from "@/pages/Products.vue"
import Services from "@/pages/Services.vue"
import Support from "@/pages/Support.vue"
import Contact from "@/pages/Contact.vue"
import Subsidiaries from "@/pages/Subsidiaries.vue"
import Terms from "@/pages/Terms.vue"
import Articles from "@/pages/Articles.vue"
import Careers from "@/pages/Careers.vue"
import Catalogues from "@/pages/Catalogues.vue"
import Certificates from "@/pages/Certificates.vue"
import CookiePolicy from "@/pages/CookiePolicy.vue"
import Delivery from "@/pages/Delivery.vue"
import Factory from "@/pages/Factory.vue"
import FAQ from "@/pages/FAQ.vue"
import Feedback from "@/pages/Feedback.vue"
import Guides from "@/pages/Guides.vue"
import PrivacyPolicy from "@/pages/PrivacyPolicy.vue"
import Recycling from "@/pages/Recycling.vue"
import Returns from "@/pages/Returns.vue"
import Warranty from "@/pages/Warranty.vue"
import ProductDetail from "@/pages/ProductDetail.vue"
import ArticlesDetail from "@/pages/ArticlesDetail.vue"
import Login from "@/pages/Login.vue"
import OrderList from "@/pages/OrderList.vue"
import Confirm from "@/pages/Confirm.vue"
import Layout from "@/components/Layout.vue"
Vue.use(Router)

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/Login",
      name: "Login",
      component: Login
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/",
          name: "index",
          component: Index
        },
        {
          path: "/About",
          name: "About",
          component: About
        },
        {
          path: "/Products",
          name: "Products",
          component: Products
        },
        {
          path: "/Services",
          name: "Services",
          component: Services
        },
        {
          path: "/Support",
          name: "Support",
          component: Support
        },
        {
          path: "/Contact",
          name: "Contact",
          component: Contact
        },
        {
          path: "/Subsidiaries",
          name: "Subsidiaries",
          component: Subsidiaries
        },
        {
          path: "/Terms",
          name: "Terms",
          component: Terms
        },
        {
          path: "/Articles",
          name: "Articles",
          component: Articles
        },
        {
          path: "/Articles/:id",
          name: "ArticlesDetail",
          component: ArticlesDetail
        },
        {
          path: "/Careers",
          name: "Careers",
          component: Careers
        },
        {
          path: "/Catalogues",
          name: "Catalogues",
          component: Catalogues
        },
        {
          path: "/Certificates",
          name: "Certificates",
          component: Certificates
        },
        {
          path: "/CookiePolicy",
          name: "CookiePolicy",
          component: CookiePolicy
        },
        {
          path: "/Delivery",
          name: "Delivery",
          component: Delivery
        },
        {
          path: "/Factory",
          name: "Factory",
          component: Factory
        },
        {
          path: "/FAQ",
          name: "FAQ",
          component: FAQ
        },
        {
          path: "/Feedback",
          name: "Feedback",
          component: Feedback
        },
        {
          path: "/Guides",
          name: "Guides",
          component: Guides
        },
        {
          path: "/PrivacyPolicy",
          name: "PrivacyPolicy",
          component: PrivacyPolicy
        },
        {
          path: "/Recycling",
          name: "Recycling",
          component: Recycling
        },
        {
          path: "/Returns",
          name: "Returns",
          component: Returns
        },
        {
          path: "/Warranty",
          name: "Warranty",
          component: Warranty
        },
        {
          path: "/productDetail",
          name: "productDetail",
          component: ProductDetail
        },
        {
          path: "/OrderList",
          name: "OrderList",
          component: OrderList
        },
        {
          path: "/Confirm",
          name: "Confirm",
          component: Confirm
        },
        {
          path: "*",
          redirect: "/"
        }
      ]
    }
  ]
})
